import { ADMIN_API } from "./common";
import { Logout } from "./Funcation";
import { postApi } from "../service";

let started = false;

/** Start the website request before the login screen paints. */
export function prefetchAdminSite(dispatch: (action: any) => void) {
  if (started) return;
  started = true;
  postApi({
    api: ADMIN_API.SETTING.WEBSITE.GET_SITE,
    value: { domain: window.location.hostname },
  })
    .then((response) => {
      if (response?.data?.data) {
        dispatch({ type: "DOMAIN_DETAILS", payload: response.data.data });
      } else {
        dispatch({ type: "DOMAIN_DETAILS_FAILED" });
      }
    })
    .catch((err) => {
      dispatch({ type: "DOMAIN_DETAILS_FAILED" });
      if (err?.response?.data?.statusCode === 401) {
        dispatch({ type: "LOGOUT" });
        Logout();
      }
    });
}
